import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faCalendar,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Modal, Button } from "react-bootstrap";
import SearchDateBox from "../../SearchDateBox";

import { Link } from "react-router-dom";
import { Chart as ChartJS } from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import ChartExpandModal from "../../../services/utilities/ChartExpandModal";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class LeaseExpiryOccupiersGraphOwner extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
    this.state = {
      expandChartKey: Math.random(),
      expandChart: false,
      filters: "",
      isOpen: false,
      start_date: "",
      end_date: "",
      which_date: "",
      which_date_name: "",
      tooltipClassname: null,
      tooltipArrow: faCaretUp,
      tooltipArrowDisplay: "none",
      tooltipYLabel: null,
      tooltipYPercentDiff: null,
      tooltipxLabel: null,
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
      xAxis: [],
    };
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }

    apiMiddleware
      .post(
        "api/edge/office/get_owner_lease_expiry_tenants",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ xAxis: res.data.x });
      });
    this.state.filters = filters;
    const superClass = this;
    const options = {
      responsive: true,
      scales: {
        x: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: this.state.mode == "quarterly" || this.state.mode == "quarter" ? "Quarters" : "Years",
          },
          ticks: {
            callback: function (label, index, labels) {
              if (/\s/.test(superClass.state.xAxis)) {
                return superClass.state.xAxis[index].split(" ");
              } else {
                return superClass.state.xAxis[index];
              }
            },
            autoSkip: false,
          },
        },
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "Area (msf)",
          },
        },
        y1: {
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "Number of Tenants",
          },
          position: "right",
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
          external: function (context) {
            var className = "colorGreen";
            var arrowDir = faCaretUp;
            var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
            var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
            if (
              parseFloat(
                context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
              ) <
              parseFloat(
                context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
              )
            ) {
              className = "colorRed";
              arrowDir = faCaretDown;
            }
            var PrecentDiff =
              parseFloat(
                ((parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                ) -
                  parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                  )) *
                  100) /
                  parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                  )
              ).toFixed(2) + "%";
            if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
              PrecentDiff = "";
            }
            superClass.setState({
              tooltipClassname: className,
              tooltipArrow: arrowDir,
              tooltipArrowDisplay: "",
              tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
              tooltipxLabel: context.tooltip.dataPoints[0].label,
              tooltipYPercentDiff: PrecentDiff,
            });
          },
        },
      },
    };

    apiMiddleware
      .post(
        "api/edge/office/get_owner_lease_expiry_tenants",
        BodyAsFormData(filters)
      )
      .then((res) => {
        const data = {
          labels: res.data.x,
          datasets: [
            {
              type: "line",
              label: res.data.legend.y1,
              data: res.data.datapoints.y1,
              backgroundColor: res.data.bgcolor.y1,
              borderColor: res.data.bgcolor.y1,
              yAxisID: "y",
            },
            {
              type: "bar",
              label: res.data.legend.y2,
              data: res.data.datapoints.y2,
              backgroundColor: res.data.bgcolor.y2,
              borderWidth: 0,
              barThickness: 10,
              borderRadius: 10,
              yAxisID: "y1",
            },
          ],
        };

        superClass.setState({
          chartOtions: options,
          chartData: data,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      const superClass = this;
      const options = {
        responsive: true,
        scales: {
          x: {
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: this.state.mode == "quarterly" || this.state.mode == "quarter" ? "Quarters" : "Years",
            },
            ticks: {
              callback: function (label, index, labels) {
                if (/\s/.test(superClass.state.xAxis)) {
                  return superClass.state.xAxis[index].split(" ");
                } else {
                  return superClass.state.xAxis[index];
                }
              },
              autoSkip: false,
            },
          },
          y: {
            grid: {
              display: true,
              drawBorder: true,
            },
            title: {
              display: true,
              text: "Area (msf)",
            },
          },
          y1: {
            grid: {
              display: true,
              drawBorder: true,
            },
            title: {
              display: true,
              text: "Number of Tenants",
            },
            position: "right",
          },
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "rgb(0, 0, 0)",
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          title: {
            display: false,
          },
          tooltip: {
            enabled: true,
            y: "bottom",
            backgroundColor: "#000",
            external: function (context) {
              var className = "colorGreen";
              var arrowDir = faCaretUp;
              var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
              var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
              if (
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                ) <
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                )
              ) {
                className = "colorRed";
                arrowDir = faCaretDown;
              }
              var PrecentDiff =
                parseFloat(
                  ((parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                  ) -
                    parseFloat(
                      context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                    )) *
                    100) /
                    parseFloat(
                      context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                    )
                ).toFixed(2) + "%";
              if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
                PrecentDiff = "";
              }
              superClass.setState({
                tooltipClassname: className,
                tooltipArrow: arrowDir,
                tooltipArrowDisplay: "",
                tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                tooltipxLabel: context.tooltip.dataPoints[0].label,
                tooltipYPercentDiff: PrecentDiff,
              });
            },
          },
        },
      };
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
      }

      apiMiddleware
        .post("api/edge/office/get_owner_lease_expiry_tenants", body)
        .then((res) => {
          const data = {
            labels: res.data.x,
            datasets: [
              {
                type: "line",
                label: res.data.legend.y1,
                data: res.data.datapoints.y1,
                backgroundColor: res.data.bgcolor.y1,
                borderColor: res.data.bgcolor.y1,
                yAxisID: "y",
              },
              {
                type: "bar",
                label: res.data.legend.y2,
                data: res.data.datapoints.y2,
                backgroundColor: res.data.bgcolor.y2,
                borderWidth: 0,
                barThickness: 10,
                borderRadius: 10,
                yAxisID: "y1",
              },
            ],
          };

          superClass.setState({
            chartOtions: options,
            chartData: data,
          });
        });
    }
  }
  downloadPdf() {
    const input = document.getElementById("leaseExpiryOccupiers");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("leaseExpiryOccupiers.pdf");
    });
  }
  dateFilter = (dateValue) => {
    // console.log(dateValue);
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };
  openModal = () => {
    this.setState({ isOpen: true });
  };
  closeModal = () => this.setState({ isOpen: false });

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    data.dateType = this.state.which_date;
    data.dateTypeName = this.state.which_date_name;
    return (
      <div className="widget widgetGraph" id="leaseExpiryOccupiers">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Lease Expiry & Occupiers</p>
            {this.state.start_date.length > 0 &&
              this.state.end_date.length > 0 &&
              this.state.start_date != "ull" &&
              this.state.which_date.length > 0 && (
                <p className="dateFont">
                  {this.state.start_date} To {this.state.end_date}
                </p>
              )}
            <h4 className={this.state.tooltipClassname}>
              <FontAwesomeIcon
                icon={this.state.tooltipArrow}
                style={{ display: this.state.tooltipArrowDisplay }}
              />
              {this.state.tooltipYPercentDiff}
            </h4>
            <p className="colorBlack pSmall">{this.state.tooltipxLabel}</p>
          </div>
          <div className="col-lg-3 text-end">
            {/* <p className="colorBlack downloads me-2">
              <FontAwesomeIcon
                icon={faCalendar}
                className="dateOptions"
                onClick={(e) => {
                  this.openModal();
                  // this.opendatePopup();
                }}
              />
            </p> */}
            <p className="colorBlack downloads">
              <FontAwesomeIcon icon={faEllipsisV} />
              <ul className="downloadOptions">
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.openModal();
                  }}
                >
                  Select Date Range
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.setState({
                      expandChart: true,
                      expandChartKey: Math.random(),
                    });
                  }}
                >
                  Expand Chart
                </li>
              </ul>
            </p>
          </div>
          <div className="col-lg-12">
            <Bar options={this.state.chartOtions} data={this.state.chartData} />
          </div>
          <div className="row">
            <div className="col-lg-12 chartSearchBox">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                className="columnsModal selectColumn downloadImgModal chartModal"
                size="lg"
              >
                <Modal.Body>
                  <SearchDateBox
                    datechildFilter={this.dateFilter}
                    parentData={data}
                  />
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <ChartExpandModal
          openModal={this.state.expandChart}
          chartName={LeaseExpiryOccupiersGraphOwner}
          key={this.state.expandChartKey}
          filters={this.state.filters}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(LeaseExpiryOccupiersGraphOwner);
